import { render, staticRenderFns } from "./ProductsFieldsValueDetails.vue?vue&type=template&id=e17b1658&scoped=true"
import script from "./ProductsFieldsValueDetails.vue?vue&type=script&lang=ts"
export * from "./ProductsFieldsValueDetails.vue?vue&type=script&lang=ts"
import style0 from "./ProductsFieldsValueDetails.vue?vue&type=style&index=0&id=e17b1658&lang=scss"
import style1 from "./ProductsFieldsValueDetails.vue?vue&type=style&index=1&id=e17b1658&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17b1658",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e17b1658')) {
      api.createRecord('e17b1658', component.options)
    } else {
      api.reload('e17b1658', component.options)
    }
    module.hot.accept("./ProductsFieldsValueDetails.vue?vue&type=template&id=e17b1658&scoped=true", function () {
      api.rerender('e17b1658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products-fields-value/components/ProductsFieldsValueDetails.vue"
export default component.exports